import { VEHICLES, INSURANCES, PROMOS, EXTRAS } from "../data/tarifas";

export function getVehicle(group) {
  return VEHICLES.find((v) => v.group === group) || null;
}

export function getInsurance(id) {
  return INSURANCES.find((i) => i.id === id) || INSURANCES[0];
}

// number of rental days (inclusive of pickup day, return same day = 1)
export function rentalDays(pickup, ret) {
  if (!pickup || !ret) return 0;
  const a = new Date(pickup);
  const b = new Date(ret);
  if (isNaN(a) || isNaN(b)) return 0;
  const ms = b.setHours(0, 0, 0, 0) - a.setHours(0, 0, 0, 0);
  if (ms < 0) return 0;
  const diff = Math.round(ms / (1000 * 60 * 60 * 24));
  return diff + 1;
}

// Sum vehicle rental across days. Mon-Thu = weekday rate, Fri-Sun = weekend rate.
// Full 7-day blocks use the weekly rate (cheaper).
function vehicleRental(vehicle, pickup, days) {
  if (!vehicle || days <= 0) return 0;
  const weeks = Math.floor(days / 7);
  const remainder = days % 7;
  let total = weeks * vehicle.week;
  const start = new Date(pickup);
  const offset = weeks * 7;
  for (let i = 0; i < remainder; i++) {
    const d = new Date(start);
    d.setDate(start.getDate() + offset + i);
    const dow = d.getDay(); // 0 Sun ... 6 Sat
    const isWeekend = dow === 5 || dow === 6 || dow === 0;
    total += isWeekend ? vehicle.weekend : vehicle.weekday;
  }
  return total;
}

function resolvePromo(promoCode) {
  const code = (promoCode || "").trim().toUpperCase();
  return PROMOS[code] || null;
}

function insuranceCostFor(insurance, group, days) {
  const perDay = insurance.perDay[group] || 0;
  return round2(perDay * days);
}

export function calcBudget({ group, insuranceId, pickup, ret, outOfHours, promoCode }) {
  const vehicle = getVehicle(group);
  const insurance = getInsurance(insuranceId);
  const days = rentalDays(pickup, ret);
  const ready = Boolean(vehicle && days > 0);

  if (!ready) {
    return {
      ready: false,
      vehicle,
      insurance,
      days,
      vehicleCost: 0,
      insuranceCost: 0,
      extrasCost: 0,
      promo: resolvePromo(promoCode),
      promoValid: Boolean(resolvePromo(promoCode)),
      discount: 0,
      total: 0,
      fianza: 0,
      kmIncluded: 0,
    };
  }

  const vehicleCost = round2(vehicleRental(vehicle, pickup, days));
  const insuranceCost = insuranceCostFor(insurance, group, days);
  const extrasCost = outOfHours ? EXTRAS.outOfHoursFee : 0;

  // promo applies to vehicle rental only
  const promo = resolvePromo(promoCode);
  const discount = promo ? round2(vehicleCost * promo.rate) : 0;

  const total = round2(vehicleCost - discount + insuranceCost + extrasCost);
  const fianza = insurance.fianza[group] || 0;
  const kmIncluded = vehicle.kmDay * days;

  return {
    ready: true,
    vehicle,
    insurance,
    days,
    vehicleCost,
    insuranceCost,
    extrasCost,
    promo,
    promoValid: Boolean(promo),
    discount,
    total,
    fianza,
    kmIncluded,
  };
}

export function eur(n) {
  return new Intl.NumberFormat("es-ES", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n || 0);
}

function round2(n) {
  return Math.round((n + Number.EPSILON) * 100) / 100;
}
